import { appConfig } from "@/commons";
import { fetchUtils } from "react-admin";

const apiUrl = appConfig.api.baseUrl;

const httpClient = (url: string, options: RequestInit = {}) => {
  const headers = new Headers(options.headers || {});

  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }

  return fetchUtils.fetchJson(url, {
    ...options,
    headers,
    credentials: "include",
  });
};

export { apiUrl, httpClient };
